import { Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { DbChangesComponent } from './components/db-changes/db-changes.component';
import { ClientsManagementComponent } from './components/clients-management/clients-management.component';
import { WorkstationsManagementComponent } from './components/workstations-management/workstations-management.component';
import { RoleTypesManagementComponent } from './components/role-types-management/role-types-management.component';
import { DatabaseMappingsComponent } from './components/database-mappings/database-mappings.component';
import { VersionLogsComponent } from './components/version-logs/version-logs.component';
import { ConfigurationPresetsComponent } from './components/configuration-presets/configuration-presets.component';
import { AdminLayoutComponent } from './components/admin-layout/admin-layout.component';
import { UserLoginComponent } from './components/user-login/user-login.component';
import { UserWelcomeComponent } from './components/user-welcome/user-welcome.component';
import { SetPasswordComponent } from './components/set-password/set-password.component';
import { LoginLogsComponent } from './components/login-logs/login-logs.component';
import { RagChatComponent } from './components/rag-chat/rag-chat.component';
import { RagDocumentsComponent } from './components/rag-documents/rag-documents.component';
import { ReportsComponent } from './components/reports/reports.component';
import { DatabasesManagementComponent } from './components/databases-management/databases-management.component';
import { AdminLoginComponent } from './components/admin-login/admin-login.component';
import { AdminChangePasswordComponent } from './components/admin-change-password/admin-change-password.component';
import { ExternalAdminsComponent } from './components/external-admins/external-admins.component';
import { AgentTasksComponent } from './components/agent-tasks/agent-tasks.component';
import { SwitchPortsComponent } from './components/switch-ports/switch-ports.component';
import { userAuthGuard } from './guards/user-auth.guard';
import { adminAuthGuard } from './guards/admin-auth.guard';

export const routes: Routes = [
  // User zone - Email/Password/OTP authentication
  { path: 'login', component: UserLoginComponent },
  { path: 'set-password', component: SetPasswordComponent },
  { path: 'welcome', component: UserWelcomeComponent, canActivate: [userAuthGuard] },
  { path: 'chat', component: RagChatComponent, canActivate: [userAuthGuard] },
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  // External admin login (Azure AD SAML SSO, external instance only)
  { path: 'admin/login', component: AdminLoginComponent },
  { path: 'admin/change-password', component: AdminChangePasswordComponent, canActivate: [adminAuthGuard] },

  // Admin zone
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [adminAuthGuard],
    children: [
      environment.externalAdminAuth
        ? { path: '', redirectTo: 'version-logs', pathMatch: 'full' as const }
        : { path: '', component: DbChangesComponent },
      { path: 'clients', component: ClientsManagementComponent },
      { path: 'workstations', component: WorkstationsManagementComponent },
      { path: 'role-types', component: RoleTypesManagementComponent },
      { path: 'database-mappings', component: DatabaseMappingsComponent },
      { path: 'version-logs', component: VersionLogsComponent },
      { path: 'config-presets', component: ConfigurationPresetsComponent },
      { path: 'login-logs', component: LoginLogsComponent },
      { path: 'rag-documents', component: RagDocumentsComponent },
      { path: 'reports', component: ReportsComponent },
      { path: 'databases', component: DatabasesManagementComponent },
      { path: 'external-admins', component: ExternalAdminsComponent },
      { path: 'agent-tasks', component: AgentTasksComponent },
      { path: 'switch-ports', component: SwitchPortsComponent },
    ]
  },

  { path: '**', redirectTo: 'login' }
];
